module.exports = __webpack_public_path__ + "static/blueteddybath1-47016b3f1e7281823e70e7a68a0d0b93.jpeg";